import { useState } from 'react';
import { Heart } from 'lucide-react';

import {
  useUserFavouriteCoaches,
  usePostUserFavouriteCoach,
  useDeleteUserFavouriteCoach
} from '@/data/userFavouriteCoach';
import { useCoaches } from '@/data/coach';

const FavouriteCoachHeart = ({ coachId }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const userFavouriteCoaches = useUserFavouriteCoaches();
  const postUserFavouriteCoach = usePostUserFavouriteCoach();
  const deleteUserFavouriteCoach = useDeleteUserFavouriteCoach();
  const coaches = useCoaches({
    favouritedBy: 'self'
  });

  if (userFavouriteCoaches.isLoading || !userFavouriteCoaches.data) {
    return null;
  }
  const isFavourite = !!userFavouriteCoaches.data[coachId];

  const handleClick = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      if (isFavourite) {
        await deleteUserFavouriteCoach(userFavouriteCoaches.data[coachId].id);
      } else {
        await postUserFavouriteCoach({ coachId });
      }
      await userFavouriteCoaches.mutate();
      await coaches.mutate();
    } finally {
      setIsSubmitting(false);
    }
  };

  const heartProps = isFavourite
    ? { color: 'var(--primary-campfire)', fill: 'var(--primary-campfire)' }
    : {};

  return (
    <div
      className="absolute z-10 top-2 right-2 p-2 cursor-pointer"
      onClick={handleClick}
    >
      <Heart
        className="transition-all duration-300 hover:scale-110 active:scale-90"
        {...heartProps}
      />
    </div>
  );
};

export default FavouriteCoachHeart;
